export default function Eyebrow({ children, tone = "palm" }) {
  const color = tone === "mango" ? "#F2A93B" : "#1F5C38";
  return (
    <span
      className="inline-flex items-center gap-2.5 text-[13px] font-bold uppercase tracking-[0.14em] mb-4"
      style={{ color }}
    >
      <span className="w-6 h-[3px] rounded-sm bg-mango" />
      {children}
    </span>
  );
}
